<template>
  <div class="sb-details-template">
    <!--
      @slot A component above the actions and back button
     -->
    <slot name="sticky-bar" />
    <SbTemplate>
      <template #header>
        <SbTemplateHeader>
          <template #left>
            <SbTemplateHeaderItem>
              <SbBackLink :to="backLinkTo">
                <sb-text :value="backLinkTitle" />
              </SbBackLink>
            </SbTemplateHeaderItem>
          </template>
          <template #right>
            <SbTemplateHeaderItem>
              <SbActionList
                v-if="actions.length"
                id="order-details-actions"
                variation="secondary"
                class="order-details__action"
                :actions="actions"
                :placement="screenSizeSmall ? 'start' : 'end'"
                @on-action="handleActionFired"
              >
                <sb-text value="common.actions" />
                <template #actions>
                  <SbActions>
                    <template #default="scope">
                      <SbAction
                        :key="scope?.action.name"
                        :value="scope?.action"
                        :disabled="scope?.action.disabled"
                      >
                        {{ scope?.action.name }}
                      </SbAction>
                    </template>
                  </SbActions>
                </template>
              </SbActionList>
            </SbTemplateHeaderItem>
          </template>
        </SbTemplateHeader>
      </template>
      <!--
      @slot Banner component to display information
     -->
      <slot
        name="banner"
      />
      <!--
      @slot Default slot for content
     -->
      <slot />
    </SbTemplate>
  </div>
</template>
<script>
import _debounce from 'lodash/debounce';

import SbBackLink from '@src/components/BackLink/SbBackLink.vue';
import SbActionList from '@src/components/ActionList/SbActionList.vue';
import SbActions from '@src/components/ActionList/components/SbActions.vue';
import SbAction from '@src/components/ActionList/components/SbAction.vue';
import SbText from '@src/components/Text/SbText.vue';
import SbTemplate from '@src/layout/Header/SbTemplate.vue';
import SbTemplateHeader from '@src/layout/Header/SbTemplateHeader.vue';
import SbTemplateHeaderItem from '@src/layout/Header/SbTemplateHeaderItem.vue';

/**
This is a details template intended to be used as a child page of the list page.
It requires a backlink title, backlink to the listpage, and an optional actions list
 */
export default {
  name: 'SbDetailsTemplate',
  components: {
    SbBackLink,
    SbActionList,
    SbActions,
    SbAction,
    SbTemplate,
    SbTemplateHeader,
    SbTemplateHeaderItem,
    SbText,
  },
  props: {
    /**
     * back link 'to' vue router link object to the list page
     */
    backLinkTo: {
      type: Object,
      required: true,
    },
    /**
     * title of the link
     */
    backLinkTitle: {
      type: String,
      required: true,
    },
    /**
     * A list of action objects
     */
    actions: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    screenSizeSmall: false,
  }),
  mounted() {
    window.addEventListener('resize', this.resizeFunc);
    this.resizeFunc();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeFunc);
  },
  methods: {
    handleActionFired(e) {
      /**
       * Emitted when an action from the action dropdown is clicked
       */
      this.$emit('on-details-action', e);
    },
    resizeFunc: _debounce(function () {
      const bp = 576;
      this.screenSizeSmall = window.innerWidth <= bp;
    }, 500),
  },
};
</script>
<style lang="scss">
@import '@src/layout/Details/style/sb-details-template.scss';
</style>
